"use client"

import React from "react"
import Navbar from "@/components/navbar"

// Unified header: main navbar + secondary services nav
export default function Header() {
  return (
    <>
      <Navbar />
    </>
  )
}
